














import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    isReadOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(_, { emit }) {
    return {
      onClickEditIcon: () => emit('edit'),
      onClickCopyIcon: () => emit('copy'),
      onClickDeleteIcon: () => emit('delete'),
    };
  },
});
